/* eslint-disable @typescript-eslint/no-explicit-any */
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
// import type { Database } from './types';

const SUPABASE_URL = 'https://yqqfxpvptgcczumqowpc.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlxcWZ4cHZwdGdjY3p1bXFvd3BjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgyMDY4MDIsImV4cCI6MjA1Mzc4MjgwMn0.cj5gWKgeumOwwTakO7-MujJOfr2jcC7Buy9yP3fUAy4';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<any>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY
);
